import { SuggestionKeyDownProps, SuggestionProps } from "@tiptap/suggestion";
import { forwardRef } from "react";
import SearchResultList from "../search/SearchResultList.tsx";
import { EntityType } from "../../Common.types.ts";
import { Box } from "@mui/material";
import { SearchResultViewModel } from "../search/SearchResultList.types.ts";

export interface MentionItem {
    id: string;
    label: string;
    entityType: EntityType;
    parentId: string | undefined;
}

type MentionRef = {
    onKeyDown: (props: SuggestionKeyDownProps) => boolean;
};

interface MentionProps extends SuggestionProps {
    items: Array<SearchResultViewModel>;
    isLoading: boolean;
    onItemSelected: (toEntityId: string, toEntityType: EntityType) => void;
    onShowMoreClick: (entityType: EntityType | undefined) => void;
    isEntitySpecificSearch: boolean;
}

export const MentionInputMentionList = forwardRef<MentionRef, MentionProps>((props, ref) => {
    const handleMouseDown = (event: React.MouseEvent) => {
        event.preventDefault();
    };

    return (
        <Box onMouseDown={handleMouseDown}>
            <SearchResultList
                items={props.items}
                isLoading={props.isLoading}
                onItemSelected={(searchResult) => {
                    const mentionItem: MentionItem = {
                        id: searchResult.entityId,
                        label: searchResult.entityName,
                        entityType: searchResult.entityType,
                        parentId: searchResult.parentId,
                    };

                    sessionStorage.setItem(`mention_${mentionItem.id}`, JSON.stringify(mentionItem));
                    props.onItemSelected(searchResult.entityId, searchResult.entityType);
                    props.command(mentionItem);
                }}
                onShowMoreClick={props.onShowMoreClick}
                isEntitySpecificSearch={props.isEntitySpecificSearch}
                ref={ref}
            />
        </Box>
    );
});

MentionInputMentionList.displayName = "MentionInputMentionList";
